<label class="verification-link" (click)="sendOTPtoClient()"
  >{{ emailOtpSend ? 'Re-send OTP' : 'Please click here ' + 'to verify your email address' }}
  <span class="inline-loader loader" [hidden]="!sendVerificationCode"></span>
</label>
<div *ngIf="emailOtpSend && !emailVerified" class="otp-text">Enter OTP sent to {{ email }} below.</div>
<div class="row" *ngIf="emailOtpSend && !emailVerified">
  <div class="col-8">
    <input class="input-control" (keypress)="verifyEmailTrigger($event)" type="text" placeholder="OTP Code" [formControl]="otpCode" />
  </div>
  <div class="col-4">
    <button
      id="verifyEmailBtn"
      [disabled]="!emailOtpSend || sendVerificationCode"
      class="btn btn-info send-otp ws-loading {{ verifyingCodeInProgress ? 'ws-loading-progress' : '' }}"
      (click)="onVerifyEmail()"
    >
      Verify
    </button>
  </div>
  <div class="col-12">
    <div class="form-errors alert alert-danger" [hidden]="!verifySignupErrors || !verifySignupErrors.length">
      <ul>
        <li class="text-left" *ngFor="let error of verifySignupErrors">
          {{ error }}
        </li>
      </ul>
    </div>
    <div class="form-errors alert alert-danger" *ngIf="otpCode.errors?.required && otpCode.touched">
      <ul>
        <li class="text-left">OTP code required</li>
      </ul>
    </div>
  </div>
</div>
